import styled from "styled-components/macro";

import { ReactComponent as IconArrow } from "../../assets/icons/icon_arrow.svg";
import { Section } from "../../components/BannerSection/styles";
import { TitleH1, TitleH2 } from "../../styles/sharedStyles";

export const Paragraph = styled.p`
    font-size: 22px;
    line-height: 140%;
    max-width: 845px;
    letter-spacing: -0.02em;
    text-align: center;
    margin: 0 auto 36px;
    
    @media (max-width: 1439px) {
      font-size: 20px;
    }
    
    @media (max-width: 979px) {
      font-size: 16px;
    }
`

export const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`

export const SubParagraph = styled(Paragraph)`
   margin: 0 auto 24px;
`

export const Img = styled.img`
  display: block;
  width: 100%;
  height: auto;
  border-radius: 24px;
  object-fit: cover;
`

export const PhotoBlock = styled.div`
  width: 100%;
  display: flex;
  gap: 24px;
    
  @media (max-width: 1439px) {
    gap: 12px;
  }
    
  @media (max-width: 979px) {
    flex-direction: column-reverse;
  }
`

export const Img2 = styled(Img)`
  width: 50%;
    
  @media (max-width: 979px) {
    width: 100%;
  }
`

export const InfoBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 50%;
  padding: 20px 0;
    
  @media (max-width: 979px) {
    width: 100%;
    align-items: center;
  }
`

export const BannerTitleH1 = styled(TitleH1)`
  color: #fff;
  margin-bottom: 36px;
  max-width: 780px;
`

export const BannerText = styled.p`
  font-size: 22px;
  color: #fff;
  letter-spacing: -0.02em;
  line-height: 140%;
  max-width: 650px;
  text-align: center;
    
  @media (max-width: 1439px) {
    font-size: 20px;
  }

  @media (max-width: 979px) {
    font-size: 16px;
  }
`

export const BannerText2 = styled(BannerText)`
  max-width: 500px;
  margin-bottom: 36px;
`

export const BannerTitleH2 = styled(TitleH2)`
  color: #fff;
  max-width: 900px;
  margin-top: 78px;
    
  @media (max-width: 979px) {
    margin-top: 0;
  }
`

export const StyledH2 = styled(TitleH2)`
  margin-bottom: 24px;
`

export const StyledP = styled(Paragraph)`
  margin: 0 0 36px;
  
  @media (max-width: 979px) {
    font-size: 20px;
    margin: 0 0 26px;
  }
`

export const TextList = styled.div`
  width: 100%;
  padding: 26px 0;
  border-top: 1px solid #B4B4B4;
  border-bottom: 1px solid #B4B4B4;
  margin-bottom: 36px;
    
  @media (max-width: 979px) {
    margin-bottom: 26px;
  }
`

export const Text = styled.p`
  font-size: 18px;
  line-height: 140%;
    
    &:not(:last-child) {
      margin-bottom: 8px;  
    }

  @media (max-width: 979px) {
    text-align: center;
  }
`

export const LinkWrapper = styled.a`
  display: flex;
  align-items: center;
  gap: 6px;
  color: #55749F;
  font-size: 18px;
  font-weight: 500;
  height: 28px;
  line-height: 100%;
  cursor: pointer;
  text-decoration: none;
  margin-bottom: 40px;
    
  @media (max-width: 979px) {
    margin-bottom: 36px;
  }
`

export const Icon = styled(IconArrow)`
  width: 22px;
  height: 13px;
    
    path {
      fill: #55749F;
    }
`

export const Text2 = styled(Text)`
    &:not(:last-child) {
      margin-bottom: 14px;
    }

  @media (max-width: 979px) {
    font-size: 15px;
    text-align: left;
    width: 100%;
  }
`

export const ResultTitle = styled(TitleH2)`
  max-width: 600px;
  margin: 0 auto 46px;
    
  @media (max-width: 979px) {
    margin-bottom: 36px;
  }
`

export const BottomBanner = styled(Section)`
  margin-bottom: 40px;

  @media (max-width: 979px) {
    margin-bottom: 0;
    padding-top: 55px;
  }   
`
